import FormElementMixin from '../mixins/FormElementMixin.js';

Vue.asyncComponent('ak-input-password', {
	mixins: [FormElementMixin],
}, 'form/controls/ak-input-password.html');